import {combineReducers} from 'redux';
import GeneralReducer from './reducers/GeneralReducer';
import ModalReducer from './reducers/ModalReducer';
import UserReducer from './reducers/UserReducer';
import BasketReducer from './reducers/BasketReducer';

const reducerCombined = combineReducers({
    GeneralReducer: GeneralReducer,
    ModalReducer: ModalReducer,
    UserReducer: UserReducer,
    BasketReducer: BasketReducer
});

export default reducerCombined;
